import { render, staticRenderFns } from "./LabelReferenceTable.vue?vue&type=template&id=776869bb&scoped=true"
import script from "./LabelReferenceTable.vue?vue&type=script&lang=js"
export * from "./LabelReferenceTable.vue?vue&type=script&lang=js"
import style0 from "./LabelReferenceTable.vue?vue&type=style&index=0&id=776869bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776869bb",
  null
  
)

export default component.exports